var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ModalBox",
    [
      _c("div", { staticClass: "link-share-modal" }, [
        _c("h3", [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.message) + ":")]),
        _vm._v(" "),
        _c("div", { ref: "shareLink", staticClass: "share__link mt-2" }, [
          _c(
            "a",
            {
              ref: "shareLinkInner",
              staticClass: "share__link__inner",
              attrs: { href: _vm.shareOptions.url },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.selectLink($event)
                }
              }
            },
            [_vm._v(_vm._s(_vm.shareOptions.url))]
          )
        ])
      ]),
      _vm._v(" "),
      _c("ShareBanner", {
        attrs: { slot: "button-group", options: _vm.shareOptions },
        slot: "button-group"
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }